import { useTranslation } from 'react-i18next'
import { SEOHead } from '@/components/SEOHead'

interface LegalPageProps {
  titleKey: string
  contentKey: string
}

export function LegalPage({ titleKey, contentKey }: LegalPageProps) {
  const { t } = useTranslation()

  return (
    <>
      <SEOHead titleKey={titleKey} />

      <section className="section-padding">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-8">{t(titleKey)}</h1>
            <div className="prose prose-gray max-w-none text-text-muted leading-relaxed space-y-4">
              <p>{t(contentKey)}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
